// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fdaa35f0","389":"08218afe","453":"9edfd4aa","732":"441d1ef8","977":"3a41141d"}[chunkId] + ".chunk.js";
};